"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Whether there is a snapshot added before auto complete and it can be undone now
 */
function canUndoAutoComplete(snapshots) {
    return (snapshots.autoCompleteIndex >= 0 &&
        snapshots.currentIndex - snapshots.autoCompleteIndex == 1);
}
exports.default = canUndoAutoComplete;
//# sourceMappingURL=canUndoAutoComplete.js.map